@if (this.fieldVisionUrl) {
  <iframe
    id="map"
    [src]="this.fieldVisionUrl | safeUrl"
    allow="local-network-access"
  ></iframe>
} @else {
  <h1>
    Uh-oh, something went wrong loading the field vision URL. Please try again!
  </h1>
}
